module.exports = __webpack_public_path__ + "img/com.faceswap.com.09abd752.png";